import { call, put, takeLatest } from 'redux-saga/effects';

function* downloadManifestById(payload) {
  try {
    yield put({
      type: "DOWNLOAD_MANIFEST_REQUESTING",
    });
    
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/wms/manifest/download/${payload.value.idManifest}`;

    const headers = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };
    const response = yield call(fetch, requestURL, headers);
    const blob = yield call([response, 'blob']);
    
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Manifest_${payload.value.idManifest}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    
    yield put({
      type: "DOWNLOAD_MANIFEST_SUCCESS",
    });
  } catch (error) {
    yield put({
      type: "DOWNLOAD_MANIFEST_ERROR",
    });
  }
}

export function* watchManifest() {
  yield takeLatest("DOWNLOAD_MANIFEST_REQUEST", downloadManifestById);
}